import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import { withNamespaces } from 'react-i18next';
import styles from '../../styles/expenseAccount.module.css';
import Webcam from "react-webcam";
import { makeStyles } from '@material-ui/core/styles';
import Slide from '@material-ui/core/Slide';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import SwitchCameraRounded from '@material-ui/icons/SwitchCameraRounded';
import i18next from 'i18next';
import { withStyles } from '@material-ui/core/styles';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import Button from '@material-ui/core/Button';


const stylesMat = theme => ({
    appBar: {
        position: 'relative',
        backgroundColor: 'var(--color1) !important',
        color: 'var(--color2) !important'
    },
    title: {
        marginLeft: theme.spacing(2),
        flex: 1,
    },
});

class ExpenseAccountCamera extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            deviceId: '',
            deviceIndex: 0,
            devices: [],
            imageData: null,
            imageName: '',
            webcam: null
        };
    }

    setRef = (webcam) => {
        this.setState({ webcam: webcam });
    }

    handleDevices = () => {
        return new Promise((resolve) => {
            if (typeof navigator.mediaDevices.enumerateDevices === "undefined") {
                resolve();
                return;
            }

            navigator.mediaDevices.enumerateDevices().then((result) => {
                const devicesVideo = result.filter(({ kind }) => kind === "videoinput");
                this.setState({ devices: devicesVideo });
                resolve();
            });
        });
    }

    componentDidMount() {
        this.handleDevices().then(() => {
            if (this.state.devices.length > 0) {
                this.setState({ deviceId: this.state.devices[0].deviceId, deviceIndex: 0 });
            }
        });
    }

    handleClose = () => {
        { this.props.onClose() }
    };

    handleRadioChange = (event) => {
        this.setState({ deviceId: event.target.value });
    };

    capture = () => {
        const imageSrc = this.state.webcam.getScreenshot();
        this.setState({ imageData: imageSrc });
    }

    handleButtonClick = () => {
        this.capture();
    }

    handleButtonCameraClick = () => {
        if (this.state.devices.length > 0) {
            let index = this.state.deviceIndex;
            if (index === (this.state.devices.length - 1)) {
                this.setState({ deviceId: this.state.devices[0].deviceId, deviceIndex: 0 });
            } else {
                index++;
                this.setState({ deviceId: this.state.devices[index].deviceId, deviceIndex: index });
            }
        }
    }

    render() {
        const { classes } = this.props;

        return (
            <Dialog onClose={this.handleClose} aria-labelledby="simple-dialog-title" open={this.props.open} fullScreen>
                <AppBar className={classes.appBar}>
                    <Toolbar>
                        <IconButton edge="start" color="inherit" onClick={this.handleClose} aria-label="close">
                            <CloseIcon />
                        </IconButton>
                        <Typography variant="h6" className={classes.title}>
                            {i18next.t('expenseAccount:option.camera')}
                        </Typography>
                    </Toolbar>
                </AppBar>
                <div className={styles.cameraWrapper}>
                    <Webcam
                        ref={this.setRef}
                        className={styles.camera}
                        audio={false}
                        videoConstraints={{ deviceId: this.state.deviceId }}
                    />
                    <div className={styles.cameraIconWrapper}>

                    </div>
                </div>
                <div className={styles.buttonWrapper}>
                    <IconButton aria-label="delete" onClick={this.handleButtonCameraClick} className={styles.cameraIcon}>
                        <SwitchCameraRounded />
                    </IconButton>
                    <Button
                        variant="contained"
                        color="primary"
                        disabled={this.state.loading}
                        onClick={this.handleButtonClick}
                        className={styles.captureButton}
                    >
                        {i18next.t('expenseAccount:option.capture')}
                    </Button>
                </div>
            </Dialog>
        );
    }
}

export default withNamespaces(['wage'], { wait: true })(withStyles(stylesMat)(ExpenseAccountCamera));